import React, { useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Space,
  message,
  Divider,
} from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  SendOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import "./ContactPage.scss";

const { Title, Text } = Typography;
const { TextArea } = Input;

const ContactPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // TODO: Replace with actual API call
      // await sendContactMessage(values);
      message.success("הודעתך נשלחה בהצלחה! נחזור אליך בהקדם.");
      form.resetFields();
    } catch (error) {
      message.error("אירעה שגיאה בשליחת ההודעה. נסה שוב מאוחר יותר.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} lg={16}>
          <Card>
            <Title level={1} style={{ textAlign: "center", marginBottom: 8 }}>
              צור קשר
            </Title>
            <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 32 }}>
              נשמח לעזור לך! מלא את הטופס ונחזור אליך בהקדם
            </Text>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="firstName"
                    label="שם פרטי"
                    rules={[{ required: true, message: "אנא הזן שם פרטי" }]}
                  >
                    <Input placeholder="הזן שם פרטי" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="lastName"
                    label="שם משפחה"
                    rules={[{ required: true, message: "אנא הזן שם משפחה" }]}
                  >
                    <Input placeholder="הזן שם משפחה" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="email"
                label="אימייל"
                rules={[
                  { required: true, message: "אנא הזן אימייל" },
                  { type: "email", message: "אנא הזן אימייל תקין" },
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="הזן כתובת אימייל"
                />
              </Form.Item>

              <Form.Item
                name="phone"
                label="טלפון"
                rules={[{ required: true, message: "אנא הזן מספר טלפון" }]}
              >
                <Input
                  prefix={<PhoneOutlined />}
                  placeholder="הזן מספר טלפון"
                />
              </Form.Item>

              <Form.Item
                name="subject"
                label="נושא"
                rules={[{ required: true, message: "אנא הזן נושא" }]}
              >
                <Input placeholder="מה הנושא?" />
              </Form.Item>

              <Form.Item
                name="message"
                label="הודעה"
                rules={[{ required: true, message: "אנא הזן הודעה" }]}
              >
                <TextArea
                  rows={6}
                  placeholder="כתוב את הודעתך כאן..."
                  showCount
                  maxLength={1000}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SendOutlined />}
                  size="large"
                  block
                >
                  שלח הודעה
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>

        <Col xs={24} lg={8}>
          <Card>
            <Title level={3}>פרטי יצירת קשר</Title>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <div>
                <PhoneOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                <Text strong>טלפון:</Text>
                <br />
                <Text>1-800-HOTELS</Text>
              </div>
              <Divider />
              <div>
                <MailOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                <Text strong>אימייל:</Text>
                <br />
                <Text>info@hotelsriver.com</Text>
              </div>
              <Divider />
              <div>
                <EnvironmentOutlined
                  style={{ marginLeft: 8, color: "#1890ff" }}
                />
                <Text strong>כתובת:</Text>
                <br />
                <Text>ישראל</Text>
              </div>
              <Divider />
              <div>
                <WhatsAppOutlined style={{ marginLeft: 8, color: "#25D366" }} />
                <Text strong>WhatsApp:</Text>
                <br />
                <Button
                  type="link"
                  href="https://wa.me/972501234567"
                  target="_blank"
                  icon={<WhatsAppOutlined />}
                >
                  שלח הודעה ב-WhatsApp
                </Button>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactPage;

